export const CHROME_STORE_URL =
  "https://chrome.google.com/webstore/detail/lets-pointie/mlabiphbgnehhigedcdklojghfpjhomi";
export const FIREFOX_STORE_URL = "https://addons.mozilla.org/en-US/firefox/addon/let-s-pointie/";
export const EDGE_STORE_URL =
  "https://microsoftedge.microsoft.com/addons/detail/lets-pointie/dnijipfilicfemiofeaniokiedakchgk";

// Route by browser:
//   Firefox (incl. iOS FxiOS)   → AMO
//   Microsoft Edge (Chromium-based, EdgiOS, EdgA, legacy EdgeHTML) → Microsoft Edge Add-ons
//   Everyone else (Chrome, Opera, Brave, Arc, Vivaldi, Safari, SSR/Node) → Chrome Web Store
// Edge UA tokens: "Edg/" (desktop Chromium), "EdgiOS/" (iOS), "EdgA/" (Android),
// "Edge/" (legacy EdgeHTML, very rare). Match all four with a single regex.
export function getDownloadUrl() {
  if (typeof navigator === "undefined") return CHROME_STORE_URL;
  const ua = navigator.userAgent || "";
  if (/Firefox|FxiOS/i.test(ua)) return FIREFOX_STORE_URL;
  if (/Edg(?:e|A|iOS)?\//.test(ua)) return EDGE_STORE_URL;
  return CHROME_STORE_URL;
}

const downloadPointieData = {
  type: "external",
  route: getDownloadUrl(),
  label: "download pointie",
  labelKey: "common:buttons.downloadPointie",
  color: "warning",
  icon: "download",
};

const checkOffersData = {
  type: "internal",
  route: "/offers/on-the-fly",
  label: "check offers",
  labelKey: "common:buttons.checkOffers",
  color: "info",
  icon: "search",
};

export { downloadPointieData, checkOffersData };
